/**
 * Collection promotion HLS — one sync() drives init / play / pause.
 */
(function () {
  'use strict';

  if (window.__collectionPromotionHlsBound) return;
  window.__collectionPromotionHlsBound = true;

  var POLL_MS = 200;
  var POLL_DURATION_MS = 6000;

  function ensureMutedForAutoplay(videoElement) {
    videoElement.muted = true;
    videoElement.setAttribute('muted', '');
    videoElement.setAttribute('playsinline', '');
  }

  /**
   * Use a rect that has size (tile container can be 0×0 before poster/video layout).
   */
  function getOverlapRect(element) {
    var rect = element.getBoundingClientRect();
    if (rect.width >= 2 && rect.height >= 2) return rect;
    var wrap = element.closest('.f-column') || element.closest('.collection-promotion');
    if (wrap) {
      var r2 = wrap.getBoundingClientRect();
      if (r2.width >= 2 && r2.height >= 2) return r2;
    }
    return rect;
  }

  function overlapsViewport(element) {
    var rect = getOverlapRect(element);
    if (rect.width < 1 || rect.height < 1) return false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    return rect.top < vh && rect.bottom > 0 && rect.left < vw && rect.right > 0;
  }

  function fullyOutsideViewport(element) {
    var rect = getOverlapRect(element);
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    return rect.bottom <= 0 || rect.top >= vh || rect.right <= 0 || rect.left >= vw;
  }

  function getHlsContainers() {
    var root = document.getElementById('ProductGridContainer');
    if (!root) return [];
    return Array.from(root.querySelectorAll('.collection-promotion__hls-video'));
  }

  function wireGlobalListenersOnce() {
    if (window.__collectionPromotionGlobalListeners) return;
    window.__collectionPromotionGlobalListeners = true;

    var scheduled = false;
    function runAllSync() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        getHlsContainers().forEach(function (el) {
          if (typeof el._promotionSync === 'function') el._promotionSync();
        });
      });
    }

    window.addEventListener('scroll', runAllSync, { passive: true });
    window.addEventListener('resize', runAllSync);
  }

  function startShortPoll(container) {
    if (container._promotionPollUntil) return;
    var start = Date.now();
    container._promotionPollUntil = setInterval(function () {
      if (!document.contains(container)) {
        clearInterval(container._promotionPollUntil);
        container._promotionPollUntil = null;
        return;
      }
      if (typeof container._promotionSync === 'function') container._promotionSync();
      if (Date.now() - start > POLL_DURATION_MS) {
        clearInterval(container._promotionPollUntil);
        container._promotionPollUntil = null;
      }
    }, POLL_MS);
  }

  function initializeHLSVideo(container, videoUrl, videoElement, posterImg, onReadySync) {
    if (videoElement.dataset.initialized === 'true') return;

    var canNative =
      videoElement.canPlayType('application/vnd.apple.mpegurl') ||
      videoElement.canPlayType('application/x-mpegURL') ||
      videoElement.canPlayType('vnd.apple.mpegURL');

    if (canNative) {
      ensureMutedForAutoplay(videoElement);
      videoElement.src = videoUrl;
      videoElement.style.display = 'block';
      videoElement.dataset.initialized = 'true';

      videoElement.addEventListener(
        'loadedmetadata',
        function () {
          ensureMutedForAutoplay(videoElement);
          videoElement.play().catch(function () {});
          if (typeof onReadySync === 'function') onReadySync();
        },
        { once: true }
      );

      videoElement.addEventListener('play', function () {
        if (posterImg) container.classList.add('playing');
      });
      videoElement.addEventListener('pause', function () {
        if (posterImg) container.classList.remove('playing');
      });
      return;
    }

    if (typeof Hls === 'undefined' || !Hls.isSupported()) {
      return;
    }

    if (videoElement.dataset.hlsSetupStarted === 'true') return;
    videoElement.dataset.hlsSetupStarted = 'true';

    if (container._hlsInstance) {
      try {
        container._hlsInstance.destroy();
      } catch (e) {}
      container._hlsInstance = null;
    }

    var hls = new Hls({
      enableWorker: true,
      lowLatencyMode: false,
      backBufferLength: 90,
    });

    hls.loadSource(videoUrl);
    hls.attachMedia(videoElement);
    container._hlsInstance = hls;

    hls.on(Hls.Events.MANIFEST_PARSED, function () {
      ensureMutedForAutoplay(videoElement);
      videoElement.style.display = 'block';
      videoElement.dataset.initialized = 'true';
      videoElement.play().catch(function () {});
      if (typeof onReadySync === 'function') onReadySync();
    });

    videoElement.addEventListener('play', function () {
      if (posterImg) container.classList.add('playing');
    });
    videoElement.addEventListener('pause', function () {
      if (posterImg) container.classList.remove('playing');
    });

    hls.on(Hls.Events.ERROR, function (event, data) {
      if (!data.fatal) return;
      switch (data.type) {
        case Hls.ErrorTypes.NETWORK_ERROR:
          hls.startLoad();
          break;
        case Hls.ErrorTypes.MEDIA_ERROR:
          hls.recoverMediaError();
          break;
        default:
          hls.destroy();
          container._hlsInstance = null;
      }
    });
  }

  function initHLSVideos() {
    var hlsContainers = getHlsContainers();
    if (hlsContainers.length === 0) return;

    wireGlobalListenersOnce();

    hlsContainers.forEach(function (container) {
      var videoUrl = container.getAttribute('data-hls-url');
      var videoElement = container.querySelector('.collection-promotion__hls-player');
      var posterImg = container.querySelector('.collection-promotion__hls-poster');

      if (!videoUrl || !videoElement) return;

      function sync() {
        if (!document.contains(container)) return;

        var inView = overlapsViewport(container);
        var offScreen = fullyOutsideViewport(container);

        if (videoElement.dataset.initialized !== 'true') {
          if (inView) {
            initializeHLSVideo(container, videoUrl, videoElement, posterImg, sync);
          }
          return;
        }

        if (offScreen) {
          if (!videoElement.paused) videoElement.pause();
          if (posterImg) container.classList.remove('playing');
          return;
        }

        if (inView && videoElement.paused) {
          ensureMutedForAutoplay(videoElement);
          videoElement.play().catch(function () {});
        }
      }

      if (container._promotionSync) {
        container._promotionSync();
        return;
      }

      container._promotionSync = sync;

      var observer = new IntersectionObserver(
        function () {
          sync();
        },
        { root: null, rootMargin: '0px 0px', threshold: 0 }
      );
      observer.observe(container);

      sync();
      requestAnimationFrame(function () {
        requestAnimationFrame(sync);
      });
      window.setTimeout(sync, 0);
      window.setTimeout(sync, 100);
      window.setTimeout(sync, 350);
      startShortPoll(container);

      if (posterImg && !posterImg.complete) {
        posterImg.addEventListener('load', sync, { once: true });
      }
    });
  }

  function scheduleInit() {
    setTimeout(initHLSVideos, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }

  document.addEventListener('collection:rerendered', scheduleInit);

  if (typeof Hls === 'undefined') {
    var check = 0;
    var hlsCheck = setInterval(function () {
      if (typeof Hls !== 'undefined' || check++ > 80) {
        clearInterval(hlsCheck);
        if (typeof Hls !== 'undefined') scheduleInit();
      }
    }, 100);
  }
})();
